import React from 'react';
import { getColorHex } from '../../utils/colorUtils';

const ColorDot = ({ colorName, size = 'md' }) => {
  if (!colorName) return null;
  
  const normalizedColorName = colorName.toLowerCase().trim();
  const isHam = normalizedColorName === 'ham';
  const isDijital = normalizedColorName === 'dijital';
  
  const hexColor = getColorHex(colorName);
  const bgColor = hexColor || '#808080'; // Gri fallback
  
  // Açık renkler için border ekle
  const isLightColor = hexColor && (
    hexColor === '#FFFFFF' ||
    hexColor === '#FDFDFD' ||
    hexColor === '#F4F4F4' ||
    hexColor === '#F2E8D5' ||
    hexColor === '#F3E7CE' ||
    hexColor === '#E6D7B8' ||
    hexColor === '#E8DCC7' ||
    hexColor === '#D6D6D6' ||
    hexColor === '#D4C9BC' ||
    hexColor === '#CFE9F7' ||
    hexColor === '#B4D9FF' ||
    hexColor === '#BFE8D8' ||
    hexColor === '#FFD7DF' ||
    hexColor === '#E6D5EF' ||
    hexColor === '#F7E7CE' ||
    hexColor === '#FAF8F2'
  );
  
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-6 h-6'
  };
  
  // Ham rengi için damalı desen
  if (isHam) {
    return (
      <div
        className={`${sizeClasses[size]} rounded-full flex-shrink-0 border border-gray-300 dark:border-gray-600 relative overflow-hidden`}
        style={{ backgroundColor: bgColor }}
        title={colorName}
      >
        {/* Damalı desen - CSS background pattern */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(45deg, rgba(0,0,0,0.1) 25%, transparent 25%),
              linear-gradient(-45deg, rgba(0,0,0,0.1) 25%, transparent 25%),
              linear-gradient(45deg, transparent 75%, rgba(0,0,0,0.1) 75%),
              linear-gradient(-45deg, transparent 75%, rgba(0,0,0,0.1) 75%)
            `,
            backgroundSize: '4px 4px',
            backgroundPosition: '0 0, 0 2px, 2px -2px, -2px 0px'
          }}
        />
      </div>
    );
  }
  
  // Dijital rengi için çok renkli desen (gökkuşağı/gradient)
  if (isDijital) {
    return (
      <div
        className={`${sizeClasses[size]} rounded-full flex-shrink-0 border border-gray-300 dark:border-gray-600 relative overflow-hidden`}
        title={colorName}
      >
        {/* Çok renkli gradient - gökkuşağı efekti */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #ff0000 0%, #ff7f00 14%, #ffff00 28%, #00ff00 42%, #0000ff 57%, #4b0082 71%, #9400d3 85%, #ff0000 100%)',
            backgroundSize: '200% 200%',
            animation: 'rainbow 3s ease infinite'
          }}
        />
        <style>{`
          @keyframes rainbow {
            0%, 100% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
          }
        `}</style>
      </div>
    );
  }
  
  return (
    <div
      className={`${sizeClasses[size]} rounded-full flex-shrink-0 ${isLightColor ? 'border border-gray-300 dark:border-gray-600' : ''}`}
      style={{ backgroundColor: bgColor }}
      title={colorName}
    />
  );
};

export default React.memo(ColorDot);

